import { render, staticRenderFns } from "./counter-party-form.vue?vue&type=template&id=23f1f406"
import script from "./counter-party-form.vue?vue&type=script&lang=js"
export * from "./counter-party-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports